import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function SelectField({
  label,
  value,
  onChange,
  options,
  error,
  required,
  helper,
  disabled,
}) {
  const [open, setOpen] = useState(false);

  const selectedLabel =
    options?.find((o) => o.value === value)?.label ?? "Select...";

  return (
    <div className="relative flex flex-col">
      <label className="text-sm font-medium text-slate-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>

      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        className={`w-full flex items-center justify-between rounded-lg border px-3 py-2.5 text-sm bg-white ${
          error ? "border-red-400" : "border-slate-200"
        } ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
      >
        <span>{selectedLabel}</span>

        {/* Dropdown Arrow */}
        <ChevronDown
          size={18}
          className={`transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && !disabled && (
        <ul className="absolute top-full mt-1 z-50 w-full bg-white border rounded-lg shadow max-h-40 overflow-y-auto">
          {options.map((opt) => (
            <li
              key={opt.value}
              className="px-3 py-2 hover:bg-slate-100 cursor-pointer text-sm"
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}

      {helper && !error && (
        <p className="mt-1 text-xs text-slate-500">{helper}</p>
      )}

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}


// import { useState } from "react";

// export default function SelectField({
//   label,
//   value,
//   onChange,
//   options,
//   error,
//   required,
//   helper,
//   disabled,
// }) {
//   const [open, setOpen] = useState(false);

//   const selectedLabel =
//   options?.find(o => o.value === value)?.label ?? "Select...";

//   return (
//     <div className="relative flex flex-col">
//       <label className="text-sm font-medium text-slate-700 mb-1">
//         {label}
//         {required && <span className="text-red-500 ml-0.5">*</span>}
//       </label>

//       <button
//         type="button"
//         disabled={disabled}
//         onClick={() => setOpen((o) => !o)}
//         className={`w-full text-left rounded-lg border px-3 py-2.5 text-sm bg-white ${
//           error ? "border-red-400" : "border-slate-200"
//         } ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
//       >
//         {selectedLabel}
//       </button>

//       {open && !disabled && (
//         <ul className="absolute top-full mt-1 z-50 w-full bg-white border rounded-lg shadow max-h-40 overflow-y-auto">
//           {options.map((opt) => (
//             <li
//               key={opt.value}
//               className="px-3 py-2 hover:bg-slate-100 cursor-pointer text-sm"
//               onClick={() => {
//                 onChange(opt.value);
//                 setOpen(false);
//               }}
//             >
//               {opt.label}
//             </li>
//           ))}
//         </ul>
//       )}

//       {helper && !error && (
//         <p className="mt-1 text-xs text-slate-500">{helper}</p>
//       )}

//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// }



// export default function SelectField({
//   label,
//   value,
//   onChange,
//   options,
//   error,
//   required,
//   helper,
//   disabled,
// }) {
//   return (
//     <div className="flex flex-col">
//       <label className="text-sm font-medium text-slate-700 mb-1">
//         {label}
//         {required && <span className="text-red-500 ml-0.5">*</span>}
//       </label>
//       <select
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         disabled={disabled}
//         className={`w-full rounded-lg border px-3 py-2.5 text-sm bg-white outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
//           error ? "border-red-400" : "border-slate-200"
//         } ${disabled ? "bg-slate-100 cursor-not-allowed" : ""}`}
//       >

//         <option value="">Select...</option>
//         {options.map((opt) => (
//           <option key={opt.value} value={opt.value}>
//             {opt.label}
//           </option>
//         ))}
//       </select>

//       {helper && !error && (
//         <p className="mt-1 text-xs text-slate-500">
//           {helper}
//         </p>
//       )}

//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// }